import { render, staticRenderFns } from "./TextToSpeechForm.vue?vue&type=template&id=0ad80086&"
import script from "./TextToSpeechForm.vue?vue&type=script&lang=js&"
export * from "./TextToSpeechForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports